import HelperEnv from './HelperEnv';

class HelperApis {
    static getBasicAuth(env) {
        const unencoded = `${env.financeFileProps.username}:${env.financeFileProps.password}`;
        return `Basic ${window.btoa(unencoded)}`;
    }
    static getBasicAuthIfPublicApi(env, settings) {
        return HelperEnv.isAuthSimulationPublic(env, settings) ? HelperApis.getBasicAuth(env) : '';
    }

    static getHeadersBasis() {
        return {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        };
    }
    static getHeaderBasicAuth(auth, clientId) {
        const result = {
            ...HelperApis.getHeadersBasis(),
            'Authorization': auth
        };
        if (clientId != null) {
            result['x-ibm-client-id'] = clientId;
        }
        return result;
    }
    static getContextAPICall(context, settings, isFinanceFile) {
        const journeyType = context.journeyType === '' ? undefined : context.journeyType;
        let contextCall = { ...context,
            componentCode: context.overrideComponentCode && 'TESTSPLUNKSYNTWID' === context.overrideComponentCode ? context.overrideComponentCode : 'GWTEST',
            overrideComponentCode:undefined, colour: undefined, 
            journeyType: journeyType,
            fastPlugCurrentDate: settings.fastPlugCurrentDate }
        if(settings.finfileResource === 'QUOTATION' && isFinanceFile){
            const customerUsage = context.customer && context.customer.clientType !== 'E' ? 'PRIV' : 'PRO';
            contextCall = {...contextCall, customer:undefined, customerUsage:customerUsage}
        }
        
        return contextCall
    }
    static getVehDescType(settings) {
        return settings != null && settings.vehDescType != null ? settings.vehDescType : 'MANUFACTURER';
    }
}

export default HelperApis
